import React from 'react'
import Screen from 'containers/Screen'
import Alerts from 'containers/Alerts'

export default function AlertasScreen () {
  return (
    <Screen title='Alertas' setHeadTitle>
      <Alerts />
    </Screen>
  )
}
